import React from 'react';
import { ReactComponent as IconComponent } from '@THC/assets/svgs/motorway-logo-wordmark.svg';
import { Icon } from '../Icon/Icon';
export const MotorwayLogoWordmarkIcon = (props) => (<Icon {...props}>
		<IconComponent />
	</Icon>);
